import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper, UserStorage } from './../../../../helper';
import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';

import { Site } from '../../../../model';
import { SiteDetailService } from './site-detail.service';
import { SiteUpdateStatusService } from './site-update-status.service';

@Component({
  selector: 'app-site-detail',
  templateUrl: './site-detail.component.html'
})
export class SiteDetailComponent implements OnInit {
  @ViewChild('warningModal') warningModal: any;
  @ViewChild('dangerModal') dangerModal: any;
  @ViewChild('equipmentLayoutPlanSuccessModal') equipmentLayoutPlanSuccessModal: any;

  id = ''; // site id
  isDownloading = false;
  isRedirect = true;
  model = new Site();
  recordSheetList = [];
  itemId = '';
  equipmentLayoutPlans = [];
  selectedEquipmentLayoutPlan = {};
  constructor(
    private userStorage: UserStorage,
    private chRef: ChangeDetectorRef,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private siteDetailService: SiteDetailService,
    private siteUpdateStatusService: SiteUpdateStatusService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit() {
    this.getDetail();
    this.getRecordSheet();
    this.getEquipmentLayoutPlan();
  }

  getDetail() {
    this.isRedirect = true;
    this.siteDetailService
      .getDetail(this.id)
      .subscribe(
        data => {
          if (data) {
            this.model = data;
          }
        },
        err => {
          $('.card').hide();
          this.exception.showError(err, 'showDanModalBtn');
        }
      );
  }

  getRecordSheet() {
    this.isRedirect = true;

    this.siteDetailService.getRecordSheet(this.id).subscribe(data => {
      this.recordSheetList = data.pmRecordSheetModel;
    }, err => {
      this.recordSheetList = [];
      this.exception.showError(err, 'showDanModalBtn');
    }, () => {
      if ($.fn.dataTable.isDataTable('#recordSheetDataTable')) {
        $('#recordSheetDataTable').DataTable().destroy();
      }

      this.chRef.detectChanges();
      const table: any = $('#recordSheetDataTable');
      table.DataTable();
    });
  }
  deleteEquipmentLayoutPlan(itemId) {
    this.selectedEquipmentLayoutPlan = this.equipmentLayoutPlans.find(x => x.itemId === itemId); 
    this.itemId = itemId;   
    this.warningModal.show();
  }
  getEquipmentLayoutPlan() {
    this.isRedirect = true;

    this.siteDetailService.getEquipmentLayoutPlans(this.id).subscribe(data => {
      this.equipmentLayoutPlans = data.plans;
    }, err => {
      this.equipmentLayoutPlans = [];
      this.exception.showError(err, 'showDanModalBtn');
    }, () => {
      if ($.fn.dataTable.isDataTable('#equipmentLayoutPlanDataTable')) {
        $('#equipmentLayoutPlanDataTable').DataTable().destroy();
      }

      this.chRef.detectChanges();
      const table: any = $('#equipmentLayoutPlanDataTable');
      table.DataTable();
    });
  }
  activate() {
    if (this.model.isActive == '0') {
      this.updateStatus();
    } else {
      this.exception.showError(null, 'showDanModalBtn');
    }

  }

  deactivate() {
    if (this.model.isActive == '1') {
      this.updateStatus();
    } else {
      this.exception.showError(null, 'showDanModalBtn');
    }

  }

  updateStatus() {
    this.siteUpdateStatusService.update(this.id).subscribe(data => {

      this.dialog.showModal('showSucModalBtn');
      this.model = data;

    },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
      });

  }

  public toSummary(): void {
    const summary = $('#summary').val();
    switch (summary) {
      case 'equipment':
        this.router.navigate(['/home/equipment/summary-by-site/' + this.id]);
        break;

      case 'record':
        // this.router.navigate(['/home/record/summary/' + this.id]);
        break;

      default:
        break;
    }
  }

  confirmEquipmentLayoutPlanRemoval() {
    this.warningModal.hide();
    this.siteDetailService.deletePlan(this.id, this.itemId).subscribe(res => {
      this.equipmentLayoutPlanSuccessModal.show();
    }, error => {
      this.exception.showError(error, 'showDanModalBtn');
    });
  }
  closeEquipmentLayoutPlanSuccessModel() {
    this.equipmentLayoutPlanSuccessModal.hide();
    this.getEquipmentLayoutPlan();
  }
  errorClose() {
    if(this.isRedirect) {
      this.router.navigate(['/home/site']);
    } else {
      this.dangerModal.hide();
    }
  }
  downloadEquipmentLayoutPlan(itemFileId) {
    this.isDownloading = true;
    this.isRedirect = false;
    this.siteDetailService.downloadEquipmentLayoutPlan(itemFileId).subscribe(data => {
      const blob = new Blob([data.file], { type: 'application/pdf' });
      saveAs(blob, data.fileName);
      this.isDownloading = false;
    }, error => {
      this.isDownloading = false;
      this.exception.showError(error, 'showDanModalBtn');
    });
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-detail/site-detail.component.ts